<template>
  <EdroneModal
    :open="props.show"
    :close-on-esc-key-press="false"
    :close-on-outside-click="false"
    :show-close-icon="false"
    :width="400"
    unique-id=""
    @close="$emit('close')"
  >
    <EdroneResultState type="success">
      <template #top-icon>
        <font-awesome-icon icon="fa-light fa-inbox" />
      </template>
      <h3 class="tw:heading-2 tw:mb-1">{{ trans._packageManager.assasRequested.title }}</h3>
      <p class="body-2 tw:!text-default-700 tw:mb-4">
        {{ trans._packageManager.assasRequested.description }}
      </p>
      <EdroneButton class="tw:w-full" type="outline" @click="emit('close')">
        {{ trans._packageManager.assasRequested.buttons.close }}
      </EdroneButton>
    </EdroneResultState>
  </EdroneModal>
</template>

<script setup lang="ts">
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneResultState from "edrone-components/EdroneResultState.vue";
import EdroneModal from "edrone-components/EdroneModal.vue";

interface Props {
  show: boolean;
}

interface Emits {
  (event: "close"): void;
}

const props = withDefaults(defineProps<Props>(), {
  show: false,
});

const emit = defineEmits<Emits>();
</script>
